import { HomeyAPI } from 'homey-api';

import { ToastManager } from '../../../ToastManager';

import { logsStore } from '../../../store/insights/LogsStore';

import { useI18n } from '../../../hooks/useI18nFormatters';
import { useLog } from '../../../store/insights/useLogs.ts';
import { useApi } from '../../../store/SelectedHomeyStore.hooks.ts';

import { glyph } from '../../../theme/glyph';

import { ContextMenuContent } from '../../../components/common/context-menu/ContextMenuContent';
import { DeveloperMenu } from '../../../components/common/context-menu/DeveloperMenu';
import { promptMessage } from '../../../components/overlay/DialogPrompt';

export function InsightContextMenuContent(props) {
  const { i18n } = useI18n();
  // const ctx = useContextMenuContext();

  const { log } = useLog({ logId: props.log.id });
  const { api } = useApi();

  function onAction(key) {
    switch (key) {
      case 'download':
        api.insights
          .getLogEntries({
            id: log.id,
            resolution: props.selectedResolutionKey,
          })
          .then((data) => {
            download({
              data,
              log: log,
              ownerName: props.ownerName,
              selectedResolutionKey: props.selectedResolutionKey,
              i18n,
            });
          })
          .catch((error) => {
            ToastManager.handleError(error);
          });
        break;
      case 'clear':
        promptMessage({
          type: 'clear',
          message: i18n.messageFormatter('prompt.clear', { name: log.title }),
        })
          .then(() => {
            api.insights
              .deleteLogEntries({
                id: log.id,
                uri: log.uri,
              })
              .then(() => {
                // invalidate log so fetchEntries is called
                // ugly
                logsStore.refresh().catch(ToastManager.handleError);
              })
              .catch((error) => {
                ToastManager.handleError(error);
              });
          })
          .catch(() => {});
        break;
      case 'delete':
        promptMessage({
          type: 'delete',
          message: i18n.messageFormatter('prompt.delete', { name: log.title }),
        })
          .then(() => {
            api.insights
              .deleteLog({
                id: log.id,
                uri: log.uri,
              })
              .then(() => {
                logsStore.refresh().catch(ToastManager.handleError);
              })
              .catch((error) => {
                ToastManager.handleError(error);
              });
          })
          .catch(() => {});
        break;
      default:
        break;
    }
  }

  return (
    <ContextMenuContent.List>
      <ContextMenuContent.ListItem
        label={i18n.messageFormatter('insights.download')}
        icon={glyph.core.arrowDownToLine}
        onPress={() => {
          onAction('download');
        }}
      />

      {HomeyAPI.isHomeyAPIV3Cloud(api) === false && (
        <ContextMenuContent.ListItem
          label={i18n.messageFormatter('insights.clear')}
          onPress={() => {
            onAction('clear');
          }}
        />
      )}

      <DeveloperMenu onIdRequest={() => props.log?.id} onResourceRequest={() => props.log} />

      <ContextMenuContent.Divider />

      <ContextMenuContent.ListItem
        label={i18n.messageFormatter('common.delete')}
        variant="danger"
        icon={glyph.core.trashFill}
        onPress={() => {
          onAction('delete');
        }}
      />
    </ContextMenuContent.List>
  );
}

function download({ data, log, ownerName, selectedResolutionKey, i18n }) {
  const resolutionTitle = i18n.messageFormatter(`insights.resolutions.${selectedResolutionKey}`);

  const delimiter = ',';
  const filename = `${ownerName} - ${log.title} (${resolutionTitle}).csv`;

  const csv = data.values.map((entry) => {
    // dateFormatter.format(new Date(entry.t), 'yyyy-MM-dd HH:mm:ss');
    const date = new Date(entry.t).toISOString();
    return `${date}${delimiter}${entry.v}`;
  });

  csv.unshift(`date${delimiter}value`);

  const csvString = csv.join('\n');

  const element = document.createElement('a');
  element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvString));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}
